export const CURRENCIES = [
  {
    country: 'AFGHANISTAN',
    currencyName: 'Afghani',
    currencyCode: 'AFN',
    currencyNumber: '971',
    currencyMinorUnits: 2
  },
  {
    country: 'ÅLAND ISLANDS',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'ALBANIA',
    currencyName: 'Lek',
    currencyCode: 'ALL',
    currencyNumber: '008',
    currencyMinorUnits: 2
  },
  {
    country: 'ALGERIA',
    currencyName: 'Algerian Dinar',
    currencyCode: 'DZD',
    currencyNumber: '012',
    currencyMinorUnits: 2
  },
  {
    country: 'AMERICAN SAMOA',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'ANDORRA',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'ANGOLA',
    currencyName: 'Kwanza',
    currencyCode: 'AOA',
    currencyNumber: '973',
    currencyMinorUnits: 2
  },
  {
    country: 'ANGUILLA',
    currencyName: 'East Caribbean Dollar',
    currencyCode: 'XCD',
    currencyNumber: '951',
    currencyMinorUnits: 2
  },
  {
    country: 'ANTIGUA AND BARBUDA',
    currencyName: 'East Caribbean Dollar',
    currencyCode: 'XCD',
    currencyNumber: '951',
    currencyMinorUnits: 2
  },
  {
    country: 'ARAB MONETARY FUND',
    currencyName: 'Arab Accounting Dinar',
    currencyCode: 'XAD',
    currencyNumber: '396',
    currencyMinorUnits: 2
  },
  {
    country: 'ARGENTINA',
    currencyName: 'Argentine Peso',
    currencyCode: 'ARS',
    currencyNumber: '032',
    currencyMinorUnits: 2
  },
  {
    country: 'ARMENIA',
    currencyName: 'Armenian Dram',
    currencyCode: 'AMD',
    currencyNumber: '051',
    currencyMinorUnits: 2
  },
  {
    country: 'ARUBA',
    currencyName: 'Aruban Florin',
    currencyCode: 'AWG',
    currencyNumber: '533',
    currencyMinorUnits: 2
  },
  {
    country: 'AUSTRALIA',
    currencyName: 'Australian Dollar',
    currencyCode: 'AUD',
    currencyNumber: '036',
    currencyMinorUnits: 2
  },
  {
    country: 'AUSTRIA',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'AZERBAIJAN',
    currencyName: 'Azerbaijan Manat',
    currencyCode: 'AZN',
    currencyNumber: '944',
    currencyMinorUnits: 2
  },
  {
    country: 'BAHAMAS (THE)',
    currencyName: 'Bahamian Dollar',
    currencyCode: 'BSD',
    currencyNumber: '044',
    currencyMinorUnits: 2
  },
  {
    country: 'BAHRAIN',
    currencyName: 'Bahraini Dinar',
    currencyCode: 'BHD',
    currencyNumber: '048',
    currencyMinorUnits: 3
  },
  {
    country: 'BANGLADESH',
    currencyName: 'Taka',
    currencyCode: 'BDT',
    currencyNumber: '050',
    currencyMinorUnits: 2
  },
  {
    country: 'BARBADOS',
    currencyName: 'Barbados Dollar',
    currencyCode: 'BBD',
    currencyNumber: '052',
    currencyMinorUnits: 2
  },
  {
    country: 'BELARUS',
    currencyName: 'Belarusian Ruble',
    currencyCode: 'BYN',
    currencyNumber: '933',
    currencyMinorUnits: 2
  },
  {
    country: 'BELGIUM',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'BELIZE',
    currencyName: 'Belize Dollar',
    currencyCode: 'BZD',
    currencyNumber: '084',
    currencyMinorUnits: 2
  },
  {
    country: 'BENIN',
    currencyName: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
    currencyNumber: '952',
    currencyMinorUnits: 0
  },
  {
    country: 'BERMUDA',
    currencyName: 'Bermudian Dollar',
    currencyCode: 'BMD',
    currencyNumber: '060',
    currencyMinorUnits: 2
  },
  {
    country: 'BHUTAN',
    currencyName: 'Indian Rupee',
    currencyCode: 'INR',
    currencyNumber: '356',
    currencyMinorUnits: 2
  },
  {
    country: 'BHUTAN',
    currencyName: 'Ngultrum',
    currencyCode: 'BTN',
    currencyNumber: '064',
    currencyMinorUnits: 2
  },
  {
    country: 'BOLIVIA (PLURINATIONAL STATE OF)',
    currencyName: 'Boliviano',
    currencyCode: 'BOB',
    currencyNumber: '068',
    currencyMinorUnits: 2
  },
  {
    country: 'BOLIVIA (PLURINATIONAL STATE OF)',
    currencyName: 'Mvdol',
    currencyCode: 'BOV',
    currencyNumber: '984',
    currencyMinorUnits: 2
  },
  {
    country: 'BONAIRE, SINT EUSTATIUS AND SABA',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'BOSNIA AND HERZEGOVINA',
    currencyName: 'Convertible Mark',
    currencyCode: 'BAM',
    currencyNumber: '977',
    currencyMinorUnits: 2
  },
  {
    country: 'BOTSWANA',
    currencyName: 'Pula',
    currencyCode: 'BWP',
    currencyNumber: '072',
    currencyMinorUnits: 2
  },
  {
    country: 'BOUVET ISLAND',
    currencyName: 'Norwegian Krone',
    currencyCode: 'NOK',
    currencyNumber: '578',
    currencyMinorUnits: 2
  },
  {
    country: 'BRAZIL',
    currencyName: 'Brazilian Real',
    currencyCode: 'BRL',
    currencyNumber: '986',
    currencyMinorUnits: 2
  },
  {
    country: 'BRITISH INDIAN OCEAN TERRITORY (THE)',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'BRUNEI DARUSSALAM',
    currencyName: 'Brunei Dollar',
    currencyCode: 'BND',
    currencyNumber: '096',
    currencyMinorUnits: 2
  },
  {
    country: 'BULGARIA',
    currencyName: 'Bulgarian Lev',
    currencyCode: 'BGN',
    currencyNumber: '975',
    currencyMinorUnits: 2
  },
  {
    country: 'BURKINA FASO',
    currencyName: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
    currencyNumber: '952',
    currencyMinorUnits: 0
  },
  {
    country: 'BURUNDI',
    currencyName: 'Burundi Franc',
    currencyCode: 'BIF',
    currencyNumber: '108',
    currencyMinorUnits: 0
  },
  {
    country: 'CABO VERDE',
    currencyName: 'Cabo Verde Escudo',
    currencyCode: 'CVE',
    currencyNumber: '132',
    currencyMinorUnits: 2
  },
  {
    country: 'CAMBODIA',
    currencyName: 'Riel',
    currencyCode: 'KHR',
    currencyNumber: '116',
    currencyMinorUnits: 2
  },
  {
    country: 'CAMEROON',
    currencyName: 'CFA Franc BEAC',
    currencyCode: 'XAF',
    currencyNumber: '950',
    currencyMinorUnits: 0
  },
  {
    country: 'CANADA',
    currencyName: 'Canadian Dollar',
    currencyCode: 'CAD',
    currencyNumber: '124',
    currencyMinorUnits: 2
  },
  {
    country: 'CAYMAN ISLANDS (THE)',
    currencyName: 'Cayman Islands Dollar',
    currencyCode: 'KYD',
    currencyNumber: '136',
    currencyMinorUnits: 2
  },
  {
    country: 'CENTRAL AFRICAN REPUBLIC (THE)',
    currencyName: 'CFA Franc BEAC',
    currencyCode: 'XAF',
    currencyNumber: '950',
    currencyMinorUnits: 0
  },
  {
    country: 'CHAD',
    currencyName: 'CFA Franc BEAC',
    currencyCode: 'XAF',
    currencyNumber: '950',
    currencyMinorUnits: 0
  },
  {
    country: 'CHILE',
    currencyName: 'Chilean Peso',
    currencyCode: 'CLP',
    currencyNumber: '152',
    currencyMinorUnits: 0
  },
  {
    country: 'CHILE',
    currencyName: 'Unidad de Fomento',
    currencyCode: 'CLF',
    currencyNumber: '990',
    currencyMinorUnits: 4
  },
  {
    country: 'CHINA',
    currencyName: 'Yuan Renminbi',
    currencyCode: 'CNY',
    currencyNumber: '156',
    currencyMinorUnits: 2
  },
  {
    country: 'CHRISTMAS ISLAND',
    currencyName: 'Australian Dollar',
    currencyCode: 'AUD',
    currencyNumber: '036',
    currencyMinorUnits: 2
  },
  {
    country: 'COCOS (KEELING) ISLANDS (THE)',
    currencyName: 'Australian Dollar',
    currencyCode: 'AUD',
    currencyNumber: '036',
    currencyMinorUnits: 2
  },
  {
    country: 'COLOMBIA',
    currencyName: 'Colombian Peso',
    currencyCode: 'COP',
    currencyNumber: '170',
    currencyMinorUnits: 2
  },
  {
    country: 'COLOMBIA',
    currencyName: 'Unidad de Valor Real',
    currencyCode: 'COU',
    currencyNumber: '970',
    currencyMinorUnits: 2
  },
  {
    country: 'COMOROS (THE)',
    currencyName: 'Comorian Franc ',
    currencyCode: 'KMF',
    currencyNumber: '174',
    currencyMinorUnits: 0
  },
  {
    country: 'CONGO (THE DEMOCRATIC REPUBLIC OF THE)',
    currencyName: 'Congolese Franc',
    currencyCode: 'CDF',
    currencyNumber: '976',
    currencyMinorUnits: 2
  },
  {
    country: 'CONGO (THE)',
    currencyName: 'CFA Franc BEAC',
    currencyCode: 'XAF',
    currencyNumber: '950',
    currencyMinorUnits: 0
  },
  {
    country: 'COOK ISLANDS (THE)',
    currencyName: 'New Zealand Dollar',
    currencyCode: 'NZD',
    currencyNumber: '554',
    currencyMinorUnits: 2
  },
  {
    country: 'COSTA RICA',
    currencyName: 'Costa Rican Colon',
    currencyCode: 'CRC',
    currencyNumber: '188',
    currencyMinorUnits: 2
  },
  {
    country: "CÔTE D'IVOIRE",
    currencyName: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
    currencyNumber: '952',
    currencyMinorUnits: 0
  },
  {
    country: 'CROATIA',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'CUBA',
    currencyName: 'Cuban Peso',
    currencyCode: 'CUP',
    currencyNumber: '192',
    currencyMinorUnits: 2
  },
  {
    country: 'CURAÇAO',
    currencyName: 'Caribbean Guilder',
    currencyCode: 'XCG',
    currencyNumber: '532',
    currencyMinorUnits: 2
  },
  {
    country: 'CYPRUS',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'CZECHIA',
    currencyName: 'Czech Koruna',
    currencyCode: 'CZK',
    currencyNumber: '203',
    currencyMinorUnits: 2
  },
  {
    country: 'DENMARK',
    currencyName: 'Danish Krone',
    currencyCode: 'DKK',
    currencyNumber: '208',
    currencyMinorUnits: 2
  },
  {
    country: 'DJIBOUTI',
    currencyName: 'Djibouti Franc',
    currencyCode: 'DJF',
    currencyNumber: '262',
    currencyMinorUnits: 0
  },
  {
    country: 'DOMINICA',
    currencyName: 'East Caribbean Dollar',
    currencyCode: 'XCD',
    currencyNumber: '951',
    currencyMinorUnits: 2
  },
  {
    country: 'DOMINICAN REPUBLIC (THE)',
    currencyName: 'Dominican Peso',
    currencyCode: 'DOP',
    currencyNumber: '214',
    currencyMinorUnits: 2
  },
  {
    country: 'ECUADOR',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'EGYPT',
    currencyName: 'Egyptian Pound',
    currencyCode: 'EGP',
    currencyNumber: '818',
    currencyMinorUnits: 2
  },
  {
    country: 'EL SALVADOR',
    currencyName: 'El Salvador Colon',
    currencyCode: 'SVC',
    currencyNumber: '222',
    currencyMinorUnits: 2
  },
  {
    country: 'EL SALVADOR',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'EQUATORIAL GUINEA',
    currencyName: 'CFA Franc BEAC',
    currencyCode: 'XAF',
    currencyNumber: '950',
    currencyMinorUnits: 0
  },
  {
    country: 'ERITREA',
    currencyName: 'Nakfa',
    currencyCode: 'ERN',
    currencyNumber: '232',
    currencyMinorUnits: 2
  },
  {
    country: 'ESTONIA',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'ESWATINI',
    currencyName: 'Lilangeni',
    currencyCode: 'SZL',
    currencyNumber: '748',
    currencyMinorUnits: 2
  },
  {
    country: 'ETHIOPIA',
    currencyName: 'Ethiopian Birr',
    currencyCode: 'ETB',
    currencyNumber: '230',
    currencyMinorUnits: 2
  },
  {
    country: 'EUROPEAN UNION',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'FALKLAND ISLANDS (THE) [MALVINAS]',
    currencyName: 'Falkland Islands Pound',
    currencyCode: 'FKP',
    currencyNumber: '238',
    currencyMinorUnits: 2
  },
  {
    country: 'FAROE ISLANDS (THE)',
    currencyName: 'Danish Krone',
    currencyCode: 'DKK',
    currencyNumber: '208',
    currencyMinorUnits: 2
  },
  {
    country: 'FIJI',
    currencyName: 'Fiji Dollar',
    currencyCode: 'FJD',
    currencyNumber: '242',
    currencyMinorUnits: 2
  },
  {
    country: 'FINLAND',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'FRANCE',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'FRENCH GUIANA',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'FRENCH POLYNESIA',
    currencyName: 'CFP Franc',
    currencyCode: 'XPF',
    currencyNumber: '953',
    currencyMinorUnits: 0
  },
  {
    country: 'FRENCH SOUTHERN TERRITORIES (THE)',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'GABON',
    currencyName: 'CFA Franc BEAC',
    currencyCode: 'XAF',
    currencyNumber: '950',
    currencyMinorUnits: 0
  },
  {
    country: 'GAMBIA (THE)',
    currencyName: 'Dalasi',
    currencyCode: 'GMD',
    currencyNumber: '270',
    currencyMinorUnits: 2
  },
  {
    country: 'GEORGIA',
    currencyName: 'Lari',
    currencyCode: 'GEL',
    currencyNumber: '981',
    currencyMinorUnits: 2
  },
  {
    country: 'GERMANY',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'GHANA',
    currencyName: 'Ghana Cedi',
    currencyCode: 'GHS',
    currencyNumber: '936',
    currencyMinorUnits: 2
  },
  {
    country: 'GIBRALTAR',
    currencyName: 'Gibraltar Pound',
    currencyCode: 'GIP',
    currencyNumber: '292',
    currencyMinorUnits: 2
  },
  {
    country: 'GREECE',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'GREENLAND',
    currencyName: 'Danish Krone',
    currencyCode: 'DKK',
    currencyNumber: '208',
    currencyMinorUnits: 2
  },
  {
    country: 'GRENADA',
    currencyName: 'East Caribbean Dollar',
    currencyCode: 'XCD',
    currencyNumber: '951',
    currencyMinorUnits: 2
  },
  {
    country: 'GUADELOUPE',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'GUAM',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'GUATEMALA',
    currencyName: 'Quetzal',
    currencyCode: 'GTQ',
    currencyNumber: '320',
    currencyMinorUnits: 2
  },
  {
    country: 'GUERNSEY',
    currencyName: 'Pound Sterling',
    currencyCode: 'GBP',
    currencyNumber: '826',
    currencyMinorUnits: 2
  },
  {
    country: 'GUINEA',
    currencyName: 'Guinean Franc',
    currencyCode: 'GNF',
    currencyNumber: '324',
    currencyMinorUnits: 0
  },
  {
    country: 'GUINEA-BISSAU',
    currencyName: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
    currencyNumber: '952',
    currencyMinorUnits: 0
  },
  {
    country: 'GUYANA',
    currencyName: 'Guyana Dollar',
    currencyCode: 'GYD',
    currencyNumber: '328',
    currencyMinorUnits: 2
  },
  {
    country: 'HAITI',
    currencyName: 'Gourde',
    currencyCode: 'HTG',
    currencyNumber: '332',
    currencyMinorUnits: 2
  },
  {
    country: 'HAITI',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'HEARD ISLAND AND McDONALD ISLANDS',
    currencyName: 'Australian Dollar',
    currencyCode: 'AUD',
    currencyNumber: '036',
    currencyMinorUnits: 2
  },
  {
    country: 'HOLY SEE (THE)',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'HONDURAS',
    currencyName: 'Lempira',
    currencyCode: 'HNL',
    currencyNumber: '340',
    currencyMinorUnits: 2
  },
  {
    country: 'HONG KONG',
    currencyName: 'Hong Kong Dollar',
    currencyCode: 'HKD',
    currencyNumber: '344',
    currencyMinorUnits: 2
  },
  {
    country: 'HUNGARY',
    currencyName: 'Forint',
    currencyCode: 'HUF',
    currencyNumber: '348',
    currencyMinorUnits: 2
  },
  {
    country: 'ICELAND',
    currencyName: 'Iceland Krona',
    currencyCode: 'ISK',
    currencyNumber: '352',
    currencyMinorUnits: 0
  },
  {
    country: 'INDIA',
    currencyName: 'Indian Rupee',
    currencyCode: 'INR',
    currencyNumber: '356',
    currencyMinorUnits: 2
  },
  {
    country: 'INDONESIA',
    currencyName: 'Rupiah',
    currencyCode: 'IDR',
    currencyNumber: '360',
    currencyMinorUnits: 2
  },
  {
    country: 'INTERNATIONAL MONETARY FUND (IMF)',
    currencyName: 'SDR (Special Drawing Right)',
    currencyCode: 'XDR',
    currencyNumber: '960',
    currencyMinorUnits: 0
  },
  {
    country: 'IRAN (ISLAMIC REPUBLIC OF)',
    currencyName: 'Iranian Rial',
    currencyCode: 'IRR',
    currencyNumber: '364',
    currencyMinorUnits: 2
  },
  {
    country: 'IRAQ',
    currencyName: 'Iraqi Dinar',
    currencyCode: 'IQD',
    currencyNumber: '368',
    currencyMinorUnits: 3
  },
  {
    country: 'IRELAND',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'ISLE OF MAN',
    currencyName: 'Pound Sterling',
    currencyCode: 'GBP',
    currencyNumber: '826',
    currencyMinorUnits: 2
  },
  {
    country: 'ISRAEL',
    currencyName: 'New Israeli Sheqel',
    currencyCode: 'ILS',
    currencyNumber: '376',
    currencyMinorUnits: 2
  },
  {
    country: 'ITALY',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'JAMAICA',
    currencyName: 'Jamaican Dollar',
    currencyCode: 'JMD',
    currencyNumber: '388',
    currencyMinorUnits: 2
  },
  {
    country: 'JAPAN',
    currencyName: 'Yen',
    currencyCode: 'JPY',
    currencyNumber: '392',
    currencyMinorUnits: 0
  },
  {
    country: 'JERSEY',
    currencyName: 'Pound Sterling',
    currencyCode: 'GBP',
    currencyNumber: '826',
    currencyMinorUnits: 2
  },
  {
    country: 'JORDAN',
    currencyName: 'Jordanian Dinar',
    currencyCode: 'JOD',
    currencyNumber: '400',
    currencyMinorUnits: 3
  },
  {
    country: 'KAZAKHSTAN',
    currencyName: 'Tenge',
    currencyCode: 'KZT',
    currencyNumber: '398',
    currencyMinorUnits: 2
  },
  {
    country: 'KENYA',
    currencyName: 'Kenyan Shilling',
    currencyCode: 'KES',
    currencyNumber: '404',
    currencyMinorUnits: 2
  },
  {
    country: 'KIRIBATI',
    currencyName: 'Australian Dollar',
    currencyCode: 'AUD',
    currencyNumber: '036',
    currencyMinorUnits: 2
  },
  {
    country: 'KOREA (THE DEMOCRATIC PEOPLE’S REPUBLIC OF)',
    currencyName: 'North Korean Won',
    currencyCode: 'KPW',
    currencyNumber: '408',
    currencyMinorUnits: 2
  },
  {
    country: 'KOREA (THE REPUBLIC OF)',
    currencyName: 'Won',
    currencyCode: 'KRW',
    currencyNumber: '410',
    currencyMinorUnits: 0
  },
  {
    country: 'KUWAIT',
    currencyName: 'Kuwaiti Dinar',
    currencyCode: 'KWD',
    currencyNumber: '414',
    currencyMinorUnits: 3
  },
  {
    country: 'KYRGYZSTAN',
    currencyName: 'Som',
    currencyCode: 'KGS',
    currencyNumber: '417',
    currencyMinorUnits: 2
  },
  {
    country: 'LAO PEOPLE’S DEMOCRATIC REPUBLIC (THE)',
    currencyName: 'Lao Kip',
    currencyCode: 'LAK',
    currencyNumber: '418',
    currencyMinorUnits: 2
  },
  {
    country: 'LATVIA',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'LEBANON',
    currencyName: 'Lebanese Pound',
    currencyCode: 'LBP',
    currencyNumber: '422',
    currencyMinorUnits: 2
  },
  {
    country: 'LESOTHO',
    currencyName: 'Loti',
    currencyCode: 'LSL',
    currencyNumber: '426',
    currencyMinorUnits: 2
  },
  {
    country: 'LESOTHO',
    currencyName: 'Rand',
    currencyCode: 'ZAR',
    currencyNumber: '710',
    currencyMinorUnits: 2
  },
  {
    country: 'LIBERIA',
    currencyName: 'Liberian Dollar',
    currencyCode: 'LRD',
    currencyNumber: '430',
    currencyMinorUnits: 2
  },
  {
    country: 'LIBYA',
    currencyName: 'Libyan Dinar',
    currencyCode: 'LYD',
    currencyNumber: '434',
    currencyMinorUnits: 3
  },
  {
    country: 'LIECHTENSTEIN',
    currencyName: 'Swiss Franc',
    currencyCode: 'CHF',
    currencyNumber: '756',
    currencyMinorUnits: 2
  },
  {
    country: 'LITHUANIA',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'LUXEMBOURG',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'MACAO',
    currencyName: 'Pataca',
    currencyCode: 'MOP',
    currencyNumber: '446',
    currencyMinorUnits: 2
  },
  {
    country: 'NORTH MACEDONIA',
    currencyName: 'Denar',
    currencyCode: 'MKD',
    currencyNumber: '807',
    currencyMinorUnits: 2
  },
  {
    country: 'MADAGASCAR',
    currencyName: 'Malagasy Ariary',
    currencyCode: 'MGA',
    currencyNumber: '969',
    currencyMinorUnits: 2
  },
  {
    country: 'MALAWI',
    currencyName: 'Malawi Kwacha',
    currencyCode: 'MWK',
    currencyNumber: '454',
    currencyMinorUnits: 2
  },
  {
    country: 'MALAYSIA',
    currencyName: 'Malaysian Ringgit',
    currencyCode: 'MYR',
    currencyNumber: '458',
    currencyMinorUnits: 2
  },
  {
    country: 'MALDIVES',
    currencyName: 'Rufiyaa',
    currencyCode: 'MVR',
    currencyNumber: '462',
    currencyMinorUnits: 2
  },
  {
    country: 'MALI',
    currencyName: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
    currencyNumber: '952',
    currencyMinorUnits: 0
  },
  {
    country: 'MALTA',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'MARSHALL ISLANDS (THE)',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'MARTINIQUE',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'MAURITANIA',
    currencyName: 'Ouguiya',
    currencyCode: 'MRU',
    currencyNumber: '929',
    currencyMinorUnits: 2
  },
  {
    country: 'MAURITIUS',
    currencyName: 'Mauritius Rupee',
    currencyCode: 'MUR',
    currencyNumber: '480',
    currencyMinorUnits: 2
  },
  {
    country: 'MAYOTTE',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'MEMBER COUNTRIES OF THE AFRICAN DEVELOPMENT BANK GROUP',
    currencyName: 'ADB Unit of Account',
    currencyCode: 'XUA',
    currencyNumber: '965',
    currencyMinorUnits: 0
  },
  {
    country: 'MEXICO',
    currencyName: 'Mexican Peso',
    currencyCode: 'MXN',
    currencyNumber: '484',
    currencyMinorUnits: 2
  },
  {
    country: 'MEXICO',
    currencyName: 'Mexican Unidad de Inversion (UDI)',
    currencyCode: 'MXV',
    currencyNumber: '979',
    currencyMinorUnits: 2
  },
  {
    country: 'MICRONESIA (FEDERATED STATES OF)',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'MOLDOVA (THE REPUBLIC OF)',
    currencyName: 'Moldovan Leu',
    currencyCode: 'MDL',
    currencyNumber: '498',
    currencyMinorUnits: 2
  },
  {
    country: 'MONACO',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'MONGOLIA',
    currencyName: 'Tugrik',
    currencyCode: 'MNT',
    currencyNumber: '496',
    currencyMinorUnits: 2
  },
  {
    country: 'MONTENEGRO',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'MONTSERRAT',
    currencyName: 'East Caribbean Dollar',
    currencyCode: 'XCD',
    currencyNumber: '951',
    currencyMinorUnits: 2
  },
  {
    country: 'MOROCCO',
    currencyName: 'Moroccan Dirham',
    currencyCode: 'MAD',
    currencyNumber: '504',
    currencyMinorUnits: 2
  },
  {
    country: 'MOZAMBIQUE',
    currencyName: 'Mozambique Metical',
    currencyCode: 'MZN',
    currencyNumber: '943',
    currencyMinorUnits: 2
  },
  {
    country: 'MYANMAR',
    currencyName: 'Kyat',
    currencyCode: 'MMK',
    currencyNumber: '104',
    currencyMinorUnits: 2
  },
  {
    country: 'NAMIBIA',
    currencyName: 'Namibia Dollar',
    currencyCode: 'NAD',
    currencyNumber: '516',
    currencyMinorUnits: 2
  },
  {
    country: 'NAMIBIA',
    currencyName: 'Rand',
    currencyCode: 'ZAR',
    currencyNumber: '710',
    currencyMinorUnits: 2
  },
  {
    country: 'NAURU',
    currencyName: 'Australian Dollar',
    currencyCode: 'AUD',
    currencyNumber: '036',
    currencyMinorUnits: 2
  },
  {
    country: 'NEPAL',
    currencyName: 'Nepalese Rupee',
    currencyCode: 'NPR',
    currencyNumber: '524',
    currencyMinorUnits: 2
  },
  {
    country: 'NETHERLANDS (THE)',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'NEW CALEDONIA',
    currencyName: 'CFP Franc',
    currencyCode: 'XPF',
    currencyNumber: '953',
    currencyMinorUnits: 0
  },
  {
    country: 'NEW ZEALAND',
    currencyName: 'New Zealand Dollar',
    currencyCode: 'NZD',
    currencyNumber: '554',
    currencyMinorUnits: 2
  },
  {
    country: 'NICARAGUA',
    currencyName: 'Cordoba Oro',
    currencyCode: 'NIO',
    currencyNumber: '558',
    currencyMinorUnits: 2
  },
  {
    country: 'NIGER (THE)',
    currencyName: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
    currencyNumber: '952',
    currencyMinorUnits: 0
  },
  {
    country: 'NIGERIA',
    currencyName: 'Naira',
    currencyCode: 'NGN',
    currencyNumber: '566',
    currencyMinorUnits: 2
  },
  {
    country: 'NIUE',
    currencyName: 'New Zealand Dollar',
    currencyCode: 'NZD',
    currencyNumber: '554',
    currencyMinorUnits: 2
  },
  {
    country: 'NORFOLK ISLAND',
    currencyName: 'Australian Dollar',
    currencyCode: 'AUD',
    currencyNumber: '036',
    currencyMinorUnits: 2
  },
  {
    country: 'NORTHERN MARIANA ISLANDS (THE)',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'NORWAY',
    currencyName: 'Norwegian Krone',
    currencyCode: 'NOK',
    currencyNumber: '578',
    currencyMinorUnits: 2
  },
  {
    country: 'OMAN',
    currencyName: 'Rial Omani',
    currencyCode: 'OMR',
    currencyNumber: '512',
    currencyMinorUnits: 3
  },
  {
    country: 'PAKISTAN',
    currencyName: 'Pakistan Rupee',
    currencyCode: 'PKR',
    currencyNumber: '586',
    currencyMinorUnits: 2
  },
  {
    country: 'PALAU',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'PANAMA',
    currencyName: 'Balboa',
    currencyCode: 'PAB',
    currencyNumber: '590',
    currencyMinorUnits: 2
  },
  {
    country: 'PANAMA',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'PAPUA NEW GUINEA',
    currencyName: 'Kina',
    currencyCode: 'PGK',
    currencyNumber: '598',
    currencyMinorUnits: 2
  },
  {
    country: 'PARAGUAY',
    currencyName: 'Guarani',
    currencyCode: 'PYG',
    currencyNumber: '600',
    currencyMinorUnits: 0
  },
  {
    country: 'PERU',
    currencyName: 'Sol',
    currencyCode: 'PEN',
    currencyNumber: '604',
    currencyMinorUnits: 2
  },
  {
    country: 'PHILIPPINES (THE)',
    currencyName: 'Philippine Peso',
    currencyCode: 'PHP',
    currencyNumber: '608',
    currencyMinorUnits: 2
  },
  {
    country: 'PITCAIRN',
    currencyName: 'New Zealand Dollar',
    currencyCode: 'NZD',
    currencyNumber: '554',
    currencyMinorUnits: 2
  },
  {
    country: 'POLAND',
    currencyName: 'Zloty',
    currencyCode: 'PLN',
    currencyNumber: '985',
    currencyMinorUnits: 2
  },
  {
    country: 'PORTUGAL',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'PUERTO RICO',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'QATAR',
    currencyName: 'Qatari Rial',
    currencyCode: 'QAR',
    currencyNumber: '634',
    currencyMinorUnits: 2
  },
  {
    country: 'RÉUNION',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'ROMANIA',
    currencyName: 'Romanian Leu',
    currencyCode: 'RON',
    currencyNumber: '946',
    currencyMinorUnits: 2
  },
  {
    country: 'RUSSIAN FEDERATION (THE)',
    currencyName: 'Russian Ruble',
    currencyCode: 'RUB',
    currencyNumber: '643',
    currencyMinorUnits: 2
  },
  {
    country: 'RWANDA',
    currencyName: 'Rwanda Franc',
    currencyCode: 'RWF',
    currencyNumber: '646',
    currencyMinorUnits: 0
  },
  {
    country: 'SAINT BARTHÉLEMY',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA',
    currencyName: 'Saint Helena Pound',
    currencyCode: 'SHP',
    currencyNumber: '654',
    currencyMinorUnits: 2
  },
  {
    country: 'SAINT KITTS AND NEVIS',
    currencyName: 'East Caribbean Dollar',
    currencyCode: 'XCD',
    currencyNumber: '951',
    currencyMinorUnits: 2
  },
  {
    country: 'SAINT LUCIA',
    currencyName: 'East Caribbean Dollar',
    currencyCode: 'XCD',
    currencyNumber: '951',
    currencyMinorUnits: 2
  },
  {
    country: 'SAINT MARTIN (FRENCH PART)',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'SAINT PIERRE AND MIQUELON',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'SAINT VINCENT AND THE GRENADINES',
    currencyName: 'East Caribbean Dollar',
    currencyCode: 'XCD',
    currencyNumber: '951',
    currencyMinorUnits: 2
  },
  {
    country: 'SAMOA',
    currencyName: 'Tala',
    currencyCode: 'WST',
    currencyNumber: '882',
    currencyMinorUnits: 2
  },
  {
    country: 'SAN MARINO',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'SAO TOME AND PRINCIPE',
    currencyName: 'Dobra',
    currencyCode: 'STN',
    currencyNumber: '930',
    currencyMinorUnits: 2
  },
  {
    country: 'SAUDI ARABIA',
    currencyName: 'Saudi Riyal',
    currencyCode: 'SAR',
    currencyNumber: '682',
    currencyMinorUnits: 2
  },
  {
    country: 'SENEGAL',
    currencyName: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
    currencyNumber: '952',
    currencyMinorUnits: 0
  },
  {
    country: 'SERBIA',
    currencyName: 'Serbian Dinar',
    currencyCode: 'RSD',
    currencyNumber: '941',
    currencyMinorUnits: 2
  },
  {
    country: 'SEYCHELLES',
    currencyName: 'Seychelles Rupee',
    currencyCode: 'SCR',
    currencyNumber: '690',
    currencyMinorUnits: 2
  },
  {
    country: 'SIERRA LEONE',
    currencyName: 'Leone',
    currencyCode: 'SLE',
    currencyNumber: '925',
    currencyMinorUnits: 2
  },
  {
    country: 'SINGAPORE',
    currencyName: 'Singapore Dollar',
    currencyCode: 'SGD',
    currencyNumber: '702',
    currencyMinorUnits: 2
  },
  {
    country: 'SINT MAARTEN (DUTCH PART)',
    currencyName: 'Caribbean Guilder',
    currencyCode: 'XCG',
    currencyNumber: '532',
    currencyMinorUnits: 2
  },
  {
    country: 'SISTEMA UNITARIO DE COMPENSACION REGIONAL DE PAGOS "SUCRE"',
    currencyName: 'Sucre',
    currencyCode: 'XSU',
    currencyNumber: '994',
    currencyMinorUnits: 0
  },
  {
    country: 'SLOVAKIA',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'SLOVENIA',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'SOLOMON ISLANDS',
    currencyName: 'Solomon Islands Dollar',
    currencyCode: 'SBD',
    currencyNumber: '090',
    currencyMinorUnits: 2
  },
  {
    country: 'SOMALIA',
    currencyName: 'Somali Shilling',
    currencyCode: 'SOS',
    currencyNumber: '706',
    currencyMinorUnits: 2
  },
  {
    country: 'SOUTH AFRICA',
    currencyName: 'Rand',
    currencyCode: 'ZAR',
    currencyNumber: '710',
    currencyMinorUnits: 2
  },
  {
    country: 'SOUTH SUDAN',
    currencyName: 'South Sudanese Pound',
    currencyCode: 'SSP',
    currencyNumber: '728',
    currencyMinorUnits: 2
  },
  {
    country: 'SPAIN',
    currencyName: 'Euro',
    currencyCode: 'EUR',
    currencyNumber: '978',
    currencyMinorUnits: 2
  },
  {
    country: 'SRI LANKA',
    currencyName: 'Sri Lanka Rupee',
    currencyCode: 'LKR',
    currencyNumber: '144',
    currencyMinorUnits: 2
  },
  {
    country: 'SUDAN (THE)',
    currencyName: 'Sudanese Pound',
    currencyCode: 'SDG',
    currencyNumber: '938',
    currencyMinorUnits: 2
  },
  {
    country: 'SURINAME',
    currencyName: 'Surinam Dollar',
    currencyCode: 'SRD',
    currencyNumber: '968',
    currencyMinorUnits: 2
  },
  {
    country: 'SVALBARD AND JAN MAYEN',
    currencyName: 'Norwegian Krone',
    currencyCode: 'NOK',
    currencyNumber: '578',
    currencyMinorUnits: 2
  },
  {
    country: 'SWEDEN',
    currencyName: 'Swedish Krona',
    currencyCode: 'SEK',
    currencyNumber: '752',
    currencyMinorUnits: 2
  },
  {
    country: 'SWITZERLAND',
    currencyName: 'Swiss Franc',
    currencyCode: 'CHF',
    currencyNumber: '756',
    currencyMinorUnits: 2
  },
  {
    country: 'SWITZERLAND',
    currencyName: 'WIR Euro',
    currencyCode: 'CHE',
    currencyNumber: '947',
    currencyMinorUnits: 2
  },
  {
    country: 'SWITZERLAND',
    currencyName: 'WIR Franc',
    currencyCode: 'CHW',
    currencyNumber: '948',
    currencyMinorUnits: 2
  },
  {
    country: 'SYRIAN ARAB REPUBLIC',
    currencyName: 'Syrian Pound',
    currencyCode: 'SYP',
    currencyNumber: '760',
    currencyMinorUnits: 2
  },
  {
    country: 'TAIWAN (PROVINCE OF CHINA)',
    currencyName: 'New Taiwan Dollar',
    currencyCode: 'TWD',
    currencyNumber: '901',
    currencyMinorUnits: 2
  },
  {
    country: 'TAJIKISTAN',
    currencyName: 'Somoni',
    currencyCode: 'TJS',
    currencyNumber: '972',
    currencyMinorUnits: 2
  },
  {
    country: 'TANZANIA, UNITED REPUBLIC OF',
    currencyName: 'Tanzanian Shilling',
    currencyCode: 'TZS',
    currencyNumber: '834',
    currencyMinorUnits: 2
  },
  {
    country: 'THAILAND',
    currencyName: 'Baht',
    currencyCode: 'THB',
    currencyNumber: '764',
    currencyMinorUnits: 2
  },
  {
    country: 'TIMOR-LESTE',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'TOGO',
    currencyName: 'CFA Franc BCEAO',
    currencyCode: 'XOF',
    currencyNumber: '952',
    currencyMinorUnits: 0
  },
  {
    country: 'TOKELAU',
    currencyName: 'New Zealand Dollar',
    currencyCode: 'NZD',
    currencyNumber: '554',
    currencyMinorUnits: 2
  },
  {
    country: 'TONGA',
    currencyName: 'Pa’anga',
    currencyCode: 'TOP',
    currencyNumber: '776',
    currencyMinorUnits: 2
  },
  {
    country: 'TRINIDAD AND TOBAGO',
    currencyName: 'Trinidad and Tobago Dollar',
    currencyCode: 'TTD',
    currencyNumber: '780',
    currencyMinorUnits: 2
  },
  {
    country: 'TUNISIA',
    currencyName: 'Tunisian Dinar',
    currencyCode: 'TND',
    currencyNumber: '788',
    currencyMinorUnits: 3
  },
  {
    country: 'TÜRKİYE',
    currencyName: 'Turkish Lira',
    currencyCode: 'TRY',
    currencyNumber: '949',
    currencyMinorUnits: 2
  },
  {
    country: 'TURKMENISTAN',
    currencyName: 'Turkmenistan New Manat',
    currencyCode: 'TMT',
    currencyNumber: '934',
    currencyMinorUnits: 2
  },
  {
    country: 'TURKS AND CAICOS ISLANDS (THE)',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'TUVALU',
    currencyName: 'Australian Dollar',
    currencyCode: 'AUD',
    currencyNumber: '036',
    currencyMinorUnits: 2
  },
  {
    country: 'UGANDA',
    currencyName: 'Uganda Shilling',
    currencyCode: 'UGX',
    currencyNumber: '800',
    currencyMinorUnits: 0
  },
  {
    country: 'UKRAINE',
    currencyName: 'Hryvnia',
    currencyCode: 'UAH',
    currencyNumber: '980',
    currencyMinorUnits: 2
  },
  {
    country: 'UNITED ARAB EMIRATES (THE)',
    currencyName: 'UAE Dirham',
    currencyCode: 'AED',
    currencyNumber: '784',
    currencyMinorUnits: 2
  },
  {
    country: 'UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND (THE)',
    currencyName: 'Pound Sterling',
    currencyCode: 'GBP',
    currencyNumber: '826',
    currencyMinorUnits: 2
  },
  {
    country: 'UNITED STATES MINOR OUTLYING ISLANDS (THE)',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'UNITED STATES OF AMERICA (THE)',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'UNITED STATES OF AMERICA (THE)',
    currencyName: 'US Dollar (Next day)',
    currencyCode: 'USN',
    currencyNumber: '997',
    currencyMinorUnits: 2
  },
  {
    country: 'URUGUAY',
    currencyName: 'Peso Uruguayo',
    currencyCode: 'UYU',
    currencyNumber: '858',
    currencyMinorUnits: 2
  },
  {
    country: 'URUGUAY',
    currencyName: 'Uruguay Peso en Unidades Indexadas (UI)',
    currencyCode: 'UYI',
    currencyNumber: '940',
    currencyMinorUnits: 0
  },
  {
    country: 'URUGUAY',
    currencyName: 'Unidad Previsional',
    currencyCode: 'UYW',
    currencyNumber: '927',
    currencyMinorUnits: 4
  },
  {
    country: 'UZBEKISTAN',
    currencyName: 'Uzbekistan Sum',
    currencyCode: 'UZS',
    currencyNumber: '860',
    currencyMinorUnits: 2
  },
  {
    country: 'VANUATU',
    currencyName: 'Vatu',
    currencyCode: 'VUV',
    currencyNumber: '548',
    currencyMinorUnits: 0
  },
  {
    country: 'VENEZUELA (BOLIVARIAN REPUBLIC OF)',
    currencyName: 'Bolívar Soberano',
    currencyCode: 'VES',
    currencyNumber: '928',
    currencyMinorUnits: 2
  },
  {
    country: 'VENEZUELA (BOLIVARIAN REPUBLIC OF)',
    currencyName: 'Bolívar Soberano',
    currencyCode: 'VED',
    currencyNumber: '926',
    currencyMinorUnits: 2
  },
  {
    country: 'VIET NAM',
    currencyName: 'Dong',
    currencyCode: 'VND',
    currencyNumber: '704',
    currencyMinorUnits: 0
  },
  {
    country: 'VIRGIN ISLANDS (BRITISH)',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'VIRGIN ISLANDS (U.S.)',
    currencyName: 'US Dollar',
    currencyCode: 'USD',
    currencyNumber: '840',
    currencyMinorUnits: 2
  },
  {
    country: 'WALLIS AND FUTUNA',
    currencyName: 'CFP Franc',
    currencyCode: 'XPF',
    currencyNumber: '953',
    currencyMinorUnits: 0
  },
  {
    country: 'WESTERN SAHARA',
    currencyName: 'Moroccan Dirham',
    currencyCode: 'MAD',
    currencyNumber: '504',
    currencyMinorUnits: 2
  },
  {
    country: 'YEMEN',
    currencyName: 'Yemeni Rial',
    currencyCode: 'YER',
    currencyNumber: '886',
    currencyMinorUnits: 2
  },
  {
    country: 'ZAMBIA',
    currencyName: 'Zambian Kwacha',
    currencyCode: 'ZMW',
    currencyNumber: '967',
    currencyMinorUnits: 2
  },
  {
    country: 'ZIMBABWE',
    currencyName: 'Zimbabwe Gold',
    currencyCode: 'ZWG',
    currencyNumber: '924',
    currencyMinorUnits: 2
  },
  {
    country: 'ZZ01_Bond Markets Unit European_EURCO',
    currencyName: 'Bond Markets Unit European Composite Unit (EURCO)',
    currencyCode: 'XBA',
    currencyNumber: '955',
    currencyMinorUnits: 0
  },
  {
    country: 'ZZ02_Bond Markets Unit European_EMU-6',
    currencyName: 'Bond Markets Unit European Monetary Unit (E.M.U.-6)',
    currencyCode: 'XBB',
    currencyNumber: '956',
    currencyMinorUnits: 0
  },
  {
    country: 'ZZ03_Bond Markets Unit European_EUA-9',
    currencyName: 'Bond Markets Unit European Unit of Account 9 (E.U.A.-9)',
    currencyCode: 'XBC',
    currencyNumber: '957',
    currencyMinorUnits: 0
  },
  {
    country: 'ZZ04_Bond Markets Unit European_EUA-17',
    currencyName: 'Bond Markets Unit European Unit of Account 17 (E.U.A.-17)',
    currencyCode: 'XBD',
    currencyNumber: '958',
    currencyMinorUnits: 0
  },
  {
    country: 'ZZ06_Testing_Code',
    currencyName: 'Codes specifically reserved for testing purposes',
    currencyCode: 'XTS',
    currencyNumber: '963',
    currencyMinorUnits: 0
  },
  {
    country: 'ZZ07_No_Currency',
    currencyName: 'The codes assigned for transactions where no currency is involved',
    currencyCode: 'XXX',
    currencyNumber: '999',
    currencyMinorUnits: 0
  },
  {
    country: 'ZZ08_Gold',
    currencyName: 'Gold',
    currencyCode: 'XAU',
    currencyNumber: '959',
    currencyMinorUnits: 0
  },
  {
    country: 'ZZ09_Palladium',
    currencyName: 'Palladium',
    currencyCode: 'XPD',
    currencyNumber: '964',
    currencyMinorUnits: 0
  },
  {
    country: 'ZZ10_Platinum',
    currencyName: 'Platinum',
    currencyCode: 'XPT',
    currencyNumber: '962',
    currencyMinorUnits: 0
  },
  {
    country: 'ZZ11_Silver',
    currencyName: 'Silver',
    currencyCode: 'XAG',
    currencyNumber: '961',
    currencyMinorUnits: 0
  }
] as const
